export default __webpack_public_path__ + "static/media/cross-ai.adc920d5.png";